<template>
    <div class="card">
        <div class="card-content">
            <div class="card-body p-1">
                <form class="form form-horizontal" enctype="multipart/form-data">
                    <div class="form-body">
                        <div class="row">
                            <div class="col-12" v-if="errorMessage.trim() !== ''">
                                <div class="form-group row">
                                    <div class="col-12">
                                        <div class="alert alert-danger">
                                            {{ errorMessage.trim() }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group row mb-0">
                                    <div class="col-md-1">
                                        <label for="durationSek">Nomlanishi</label>
                                    </div>
                                    <div class="col-md-6">
                                        <ValidationProvider name="Nomlanishi" rules="required" v-slot="{ errors }">
                                            <div class="position-relative has-icon-left">
                                                <input type="text" placeholder="Nomlanishi..." class="form-control" id="durationSek"
                                                       v-model.trim="section.name">
                                            </div>
                                            <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                                        </ValidationProvider>

                                    </div>
                                    <div class="col-md-4">
                                        <div class="d-flex">
                                            <button v-if="update" type="button" class="btn btn-info waves-effect waves-light mr-1"
                                                    @click="updateSection">
                                                Yangilash
                                            </button>

                                            <button v-else type="button" class="btn btn-info waves-effect waves-light mr-1"
                                                    @click="storeSection">
                                                Saqlash
                                            </button>

                                            <button class="btn btn-outline-info waves-effect waves-light" type="button"
                                                    @click="closeCollapse">
                                                Bekor qilish
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { ValidationProvider, extend, ValidationObserver} from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';

    extend('required', {
        ...required,
        message: 'Kiriting {_field_}'
    });

    export default {
        name: "SubjectSectionForm",
        props: {
            section: Object
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data() {
            return {
                errorMessage: '',
            }
        },
        methods: {
            storeSection() {
                this.$api.post('admin/Reference/CreateSubjectSection', this.sectionFormData())
                    .then(res => {
                        if (!res.error) {
                            this.$emit('saved');
                            this.closeCollapse();
                            this.notificationMessage('Сохранено', 'success');
                        }
                        else {
                            this.errMessage(res.error);
                        }
                    })
                    .catch(err => {
                        this.errMessage('Ошибка');
                    })
                    .finally(() => {

                    });
            },
            updateSection() {
                this.$api.put('admin/Reference/UpdateSubjectSection', this.sectionFormData())
                    .then(res => {
                        if (!res.error) {
                            this.$emit('saved');
                            this.closeCollapse();
                            this.notificationMessage('Обновлено', 'success');
                        }
                        else {
                            this.errMessage(res.error);
                        }
                    })
                    .catch(err => {
                        this.errMessage('Ошибка');
                    })
                    .finally(() => {

                    });
            },
            sectionFormData() {
                let form = new FormData();
                for (let prop in this.section)
                    form.append(prop, this.section[prop]);

                return form;
            },
            closeCollapse() {
                $('#sectionForm').collapse('hide');
            },
            errMessage(errorMessage) {
                this.errorMessage = errorMessage;
                setTimeout(() => {
                    this.errorMessage = '';
                }, 5000);
            }
        },
        computed: {
            update() {
                return this.section.id !== 0;
            }
        }
    }
</script>

<style scoped>

</style>